import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import { useLocation } from "react-router-dom";

// Pages that embed iframes — Lenis wheel capture blocks their internal scroll
const IFRAME_ROUTES = ["/chatbot", "/pagespeed", "/resumely", "/color-palette-generator", "/typography", "/vastu", "/services/website-development"];

const SmoothScroll = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isIframePage = IFRAME_ROUTES.some((r) => location.pathname.startsWith(r));

  useEffect(() => {
    // Skip Lenis entirely on iframe-heavy pages so inner scroll works
    if (isIframePage) return;

    const lenis = new Lenis({
      duration: 1,
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1.1,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, [isIframePage]);

  return <>{children}</>;
};

export default SmoothScroll;
